import React from "react"
import {Spin} from "antd";

export default function ForumLoaderSkeleton({close, getListing, setGetListing, id}) {
    return(
        <>
            <div className={'routing-loader'}>
                <Spin size="large" />  {/* Show loading spinner */}
            </div>
        </>
    )
}